import { ApolloError, QueryResult, useQuery } from '@apollo/client';
import GET_AFFIRMATIONS from '../../queries/affirmations/get-affirmations-query';
import type { Asset } from '@monorepo/shared/src/graph/schema-generated-types-student';
import { StoreTypename } from 'types';

export type AffirmationsState = {
  affirmations: Asset[] | null;
  error: ApolloError | undefined;
  loading: boolean;
};
export type AffirmationsDispatch = undefined;
export type Affirmations = [AffirmationsState, AffirmationsDispatch];

export const Affirmations = (): { __typename: string } => ({
  __typename: StoreTypename.AFFIRMATIONS,
});
export type AffirmationsProps = { id?: number[]; count?: number; randomize?: boolean };

const useAffirmationsStore = ({ id, count, randomize }: AffirmationsProps): Affirmations => {
  const { data, loading, error }: QueryResult<{ affirmations: Asset[] | undefined }> = useQuery(
    GET_AFFIRMATIONS,
    {
      fetchPolicy: 'no-cache',
      variables: { where: { id: id, count: count, randomize: randomize } },
    }
  );

  return [
    {
      affirmations: data?.affirmations || null,
      error,
      loading: loading,
    },
    undefined,
  ];
};

export default useAffirmationsStore;
